// Primera vez que alguien entra con Google y todavía no pertenece a ninguna clínica:
//  - viene de un enlace de invitación (/unirse/{org}/{codigo}) → se une al equipo de esa clínica
//  - si no → da de alta su clínica (queda de administrador, con días de prueba)
import { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { signOut } from 'firebase/auth';
import { auth, functions } from './firebase';

export const MARCA = import.meta.env.VITE_MARCA || 'VetPanel';

// Enlace de invitación de otra clínica: app.vetpanel.es/?ref=CODIGO (se guarda hasta que se dé de alta)
try { const r = new URLSearchParams(window.location.search).get('ref'); if (r) localStorage.setItem('vp-ref', r.slice(0, 60)); } catch { /* sin almacenamiento */ }
const refGuardada = () => { try { return localStorage.getItem('vp-ref') || ''; } catch { return ''; } };
// Código de acceso de la beta privada: app.vetpanel.es/?acceso=CODIGO
try { const a = new URLSearchParams(window.location.search).get('acceso'); if (a) localStorage.setItem('vp-acceso', a.slice(0, 40)); } catch { /* sin almacenamiento */ }
const accesoGuardado = () => { try { return localStorage.getItem('vp-acceso') || ''; } catch { return ''; } };
const esEquipo = (email) => /@vetpanel\.es$/i.test(email || '');

const invitacionEnRuta = () => {
  const m = window.location.pathname.match(/^\/unirse\/([a-z0-9-]{2,40})\/([a-f0-9]{20})\/?$/);
  return m ? { org: m[1], codigo: m[2] } : null;
};

// Columna izquierda de la entrada y del alta (marca, ventajas y un trozo de chat)
export function PanelMarca() {
  return (
    <section className="entrada-marca" aria-hidden="true">
      <div className="entrada-logo"><img src="/logo-blanco.png" alt="" />{MARCA}</div>
      <div className="entrada-claim">
        <h2>Tu clínica, en orden.<br /><span>Desde un solo panel.</span></h2>
        <ul>
          <li><b>WhatsApp con IA</b> que contesta 24 h y te pasa lo importante</li>
          <li><b>Cirugías, hospitalización y día a día</b> del equipo</li>
          <li><b>Facturas, banco e impuestos</b> sin hojas de cálculo</li>
        </ul>
      </div>
      <div className="entrada-chat">
        <div className="ec-m c">¿Tenéis cita mañana para vacunar a Luna?</div>
        <div className="ec-m s">Sí, mañana tenemos hueco por la tarde. ¿Le va bien a las 17:30?</div>
        <div className="ec-tag">Solicitud de cita · Luna · mañana 17:30</div>
      </div>
      <small>Creado por veterinarios, usado en nuestras clínicas.</small>
    </section>
  );
}

export const LogoGoogle = () => (
  <svg viewBox="0 0 48 48" width="20" height="20" aria-hidden="true"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/></svg>
);

export default function Alta({ user, onListo }) {
  const inv = invitacionEnRuta();
  const [modo, setModo] = useState(inv ? 'unirse' : 'inicio');
  const [estado, setEstado] = useState(null);
  const nombre = user.displayName ? user.displayName.split(' ')[0] : '';

  // Con enlace de invitación: se acepta solo al entrar
  useEffect(() => {
    if (!inv) return;
    setEstado({ cargando: true });
    httpsCallable(functions, 'aceptarInvitacion')(inv)
      .then(() => { window.history.replaceState(null, '', '/'); onListo(); })
      .catch((e) => setEstado({ error: e.message }));
  }, []);

  return (
    <div className="entrada">
      <PanelMarca />
      <section className="entrada-form">
        <main className={`entrada-caja${modo === 'alta' ? ' ancha' : ''}`}>
          <img className="entrada-logo-movil" src="/logo.png" alt="" />
          {modo === 'unirse' && (
            <>
              <h1>Uniéndote al equipo…</h1>
              {estado?.cargando && <p>Comprobando la invitación.</p>}
              {estado?.error && <><p className="error">{estado.error}</p><button className="entrada-sec" onClick={() => { window.history.replaceState(null, '', '/'); setModo('inicio'); setEstado(null); }}>Volver</button></>}
            </>
          )}
          {modo === 'inicio' && (
            <>
              <h1>Hola{nombre ? `, ${nombre}` : ''}</h1>
              <p>Has entrado como <b>{user.email}</b>. Esta cuenta todavía no está en ninguna clínica.</p>
              {accesoGuardado() || esEquipo(user.email)
                ? <button className="entrada-principal" onClick={() => setModo('alta')}>Dar de alta mi clínica</button>
                : <SinAcceso onCodigo={() => setModo('alta')} />}
              <div className="entrada-nuevo"><b>¿Trabajas en una clínica que ya usa {MARCA}?</b> No crees otra: pide a tu responsable un enlace de invitación y ábrelo con esta cuenta.</div>
            </>
          )}
          {modo === 'alta' && <FormAlta onListo={onListo} onVolver={() => setModo('inicio')} />}
          <button className="entrada-enlace" onClick={() => signOut(auth)}>Entrar con otra cuenta</button>
        </main>
        <footer className="entrada-pie">
          <a href="https://vetpanel.es">vetpanel.es</a><a href="/privacidad">Privacidad</a><a href="/condiciones">Condiciones</a>
        </footer>
      </section>
    </div>
  );
}

function SinAcceso({ onCodigo }) {
  const [abierto, setAbierto] = useState(false);
  const [c, setC] = useState('');
  return (
    <div className="entrada-beta">
      <b>Estamos en beta privada</b>
      <p>Ahora mismo damos acceso a un grupo pequeño de clínicas. Escríbenos y te avisamos en cuanto haya hueco.</p>
      <a className="entrada-principal" href="mailto:info@vetpanel.es?subject=Quiero%20probar%20VetPanel">Pedir acceso</a>
      {!abierto ? <button className="entrada-enlace" onClick={() => setAbierto(true)}>Tengo un código de acceso</button> : (
        <form className="entrada-codigo" onSubmit={(e) => { e.preventDefault(); if (!c.trim()) return; try { localStorage.setItem('vp-acceso', c.trim()); } catch { /* */ } onCodigo(); }}>
          <input className="campo" value={c} onChange={(e) => setC(e.target.value)} placeholder="Código" autoFocus />
          <button className="btn">Seguir</button>
        </form>
      )}
    </div>
  );
}

function FormAlta({ onListo, onVolver }) {
  const [f, setF] = useState({ nombre: '', ciudad: '', clinica: { nombre: '', telefono: '', razonSocial: '', cif: '', direccion: '' }, acepto: false });
  const [estado, setEstado] = useState(null);
  const pon = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const ponC = (k, v) => setF((x) => ({ ...x, clinica: { ...x.clinica, [k]: v } }));
  const enviar = async (e) => {
    e.preventDefault();
    setEstado({ cargando: true });
    try {
      await httpsCallable(functions, 'crearOrganizacion')({ ...f, ref: refGuardada(), acceso: accesoGuardado(), clinica: { ...f.clinica, nombre: f.clinica.nombre.trim() || f.nombre } });
      onListo();
    } catch (err) { setEstado({ error: err.message }); }
  };
  return (
    <form className="alta-form" onSubmit={enviar}>
      <span className="alta-paso">Paso 1 de 2 · Tu clínica</span>
      {refGuardada() && <div className="alta-regalo">Vienes invitado por otra clínica: <b>tu primer mes es gratis</b> al contratar.</div>}
      <h1>Crea tu clínica</h1>
      <p>Solo lo básico. Lo demás lo completas dentro, con calma.</p>
      <label>Nombre de la clínica<input className="campo" required minLength={3} value={f.nombre} onChange={(e) => pon('nombre', e.target.value)} placeholder="Clínica Veterinaria Ejemplo" autoFocus /></label>
      <div className="alta-dos">
        <label>Ciudad<input className="campo" value={f.ciudad} onChange={(e) => pon('ciudad', e.target.value)} placeholder="Madrid" /></label>
        <label>Teléfono<input className="campo" type="tel" value={f.clinica.telefono} onChange={(e) => ponC('telefono', e.target.value)} placeholder="600 000 000" /></label>
      </div>
      <details className="alta-mas">
        <summary>Datos de facturación y varias clínicas <span>(opcional)</span></summary>
        <label>Si tienes varias clínicas, nombre corto de esta<input className="campo" value={f.clinica.nombre} onChange={(e) => ponC('nombre', e.target.value)} placeholder="Centro" /></label>
        <label>Razón social<input className="campo" value={f.clinica.razonSocial} onChange={(e) => ponC('razonSocial', e.target.value)} placeholder="Ejemplo Veterinaria SL" /></label>
        <div className="alta-dos">
          <label>CIF<input className="campo" value={f.clinica.cif} onChange={(e) => ponC('cif', e.target.value.toUpperCase())} placeholder="B12345678" /></label>
          <label>Dirección<input className="campo" value={f.clinica.direccion} onChange={(e) => ponC('direccion', e.target.value)} placeholder="Calle, número, CP" /></label>
        </div>
      </details>
      <label className="alta-acepto">
        <input type="checkbox" checked={f.acepto} onChange={(e) => pon('acepto', e.target.checked)} />
        <span>Acepto las <a href="/condiciones" target="_blank" rel="noreferrer">condiciones del servicio</a> y el <a href="/condiciones#encargo" target="_blank" rel="noreferrer">encargo del tratamiento de datos</a>.</span>
      </label>
      {estado?.error && <p className="error">{estado.error}</p>}
      <button className="entrada-principal" disabled={estado?.cargando || !f.acepto || f.nombre.trim().length < 3}>{estado?.cargando ? 'Creando tu clínica…' : 'Crear mi clínica · 14 días gratis'}</button>
      <button type="button" className="entrada-enlace" onClick={onVolver}>← Volver</button>
    </form>
  );
}
